import { IBar } from "../types";

export const getTiriTamTiBar = (bar: IBar, withTai: boolean) => {
    const syllables: string[] = [];
    let barLength = 0;
    bar.notes.forEach((note, noteIndex) => {
        const noteLength = (4 / note.l) * (note.d ? 1.5 : 1);
        switch (noteLength) {
            case 0.25:
                if (
                    Math.round((barLength / 3) * 2) === (barLength / 3) * 2 &&
                    bar.notes.length - 1 > noteIndex &&
                    bar.notes[noteIndex + 1].l === 16
                ) {
                    syllables.push("ti");
                } else {
                    syllables.push("ri");
                }
                break;
            case 0.5:
                syllables.push("ti");
                break;
            case 0.75:
                syllables.push("tim");
                break;
            case 1:
                syllables.push("ta");
                break;
            case 1.5:
                syllables.push(withTai ? "tai" : "tam");
                break;
            case 2:
                syllables.push("taa");
                break;
            case 3:
                syllables.push("taaa");
                break;
            case 4:
                syllables.push("taaaa");
                break;
            default:
                syllables.push("?");
                break;
        }
        barLength += noteLength * (note.t ? 2 : 3);
    });
    return syllables;
};

export const getTiriTamTiScore = (bars: (IBar | null)[], withTai: boolean) => {
    const syllables: string[] = [];
    bars.forEach(bar => {
        if (!bar) return;
        syllables.push(...getTiriTamTiBar(bar, withTai));
    });
    return syllables;
};
